"use client";

import { Suspense } from "react";
import DataTabs from "@/components/DataTabs";

export default function ReversalPage() {
  return (
    <main>
      <Suspense fallback={<div>Loading...</div>}>
        <DataTabs initialTab="reversal" showTabBar={false} />
      </Suspense>
    </main>
  );
}
